
    import "src/app/AppAdmin/D2R/Invoices/index.module.scss?farm_css_modules";
    
    export default {"paymentStatusFilter": `paymentStatusFilter-f68e0ffb`,"statusFilter": `statusFilter-f68e0ffb`}
    